<script setup lang="ts">
import { markRaw } from 'vue'
import ClientsRepartitionCard from '@/components/clients/ClientsRepartition.vue'
import ClientsTableComponent from '@/components/clients/ClientsTable.vue'
import DraggableContainer from '@/components/ui/draggable/DraggableContainer.vue'
import { useComponentOrder } from '@/lib/useComponentOrder'
import ClientsInfoCard from '@/components/clients/ClientsInfoCard.vue'

const defaultComponents = [
  {
    id: 'info-card',
    component: markRaw(ClientsInfoCard),
    props: {},
  },
  {
    id: 'repartition-card',
    component: markRaw(ClientsRepartitionCard),
  },
  {
    id: 'clients-table',
    component: markRaw(ClientsTableComponent),
  },
]

const { components } = useComponentOrder('clients-page', defaultComponents)

defineOptions({
  name: 'ClientsView',
})
</script>

<template>
  <DraggableContainer v-model:components="components" />
</template>
